import styled from 'styled-components';
export const ChatHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #075e54;
  color: white;
`;

export const ChatHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  h3 {
    margin: 0;
    font-size: 16px;
  }

  p {
    margin: 0;
    font-size: 12px;
    opacity: 0.8;
  }
`;

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #e5ddd5;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;

  ${props => props.isEnded && `
    &::after {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
      position: absolute;
      height: 100%;
    }
  `}
`;

export const Message = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap:8px;
  justify-content: ${props => props.sender === 'sent' ? 'flex-end' : 'flex-start'};
`;

export const MessageContent = styled.div`
  max-width: 60%;
  padding: 8px 12px;
  border-radius: 8px;
  position: relative;
  background-color: ${props => props.sender === 'sent' ? '#dcf8c6' : 'white'};

  p {
    margin: 0;
    word-wrap: break-word;
  }
`;

export const OfficialBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background-color: #25D366;
  color: white;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 1px 5px;
  border-radius: 3px;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

export const LoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #128C7E;
  border: none;
  border-radius: 24px;
  padding: 8px 16px;
  margin: 12px auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => props.isLoading ? 'default' : 'pointer'};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  width: auto;
  min-width: 120px;
  opacity: ${props => props.isLoading ? 0.7 : 1};

  &:hover {
    background-color: ${props => props.isLoading ? '#f0f2f5' : '#e8e8e8'};
  }

  &:active {
    background-color: ${props => props.isLoading ? '#f0f2f5' : '#dcddde'};
    transform: ${props => props.isLoading ? 'none' : 'scale(0.98)'};
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 6px 12px;
  }
`;

export const LoadingMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  margin: 12px auto;
`;

export const MessageTimestamp = styled.span`
  font-size: 11px;
  color: #667781;
  float: right;
  margin-left: 8px;
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
`;

export const ChatInputForm = styled.form`
  display: flex;
  padding: 16px;
  background-color: #f0f2f5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const ChatInput = styled.textarea`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 24px;
  margin-right: 8px;
  outline: none;
  resize: none;
  min-height: 40px;
  transition: height 0.1s ease;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  padding: 8px 8px;
  height: fit-content;
  width: fit-content;
  background-color: #075e54;
  color: white;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #128c7e;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export const DateSeparator = styled.div`
text-align: center;
padding: 10px 0;
margin: 10px 0;

&::before {
    content: '';
    display: inline-block;
    background-color: #e2e2e2;
    height: 1px;
    width: 100%;
    position: relative;
    vertical-align: middle;
}

span {
    background-color: #e2e2e2;
    color: #666;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
    margin: 0 10px;
}
`;

export const CloseButton = styled.button`
background: none;
border: none;
font-size: 24px;
cursor: pointer;
padding: 0 10px;

&:hover {
    color: #666;
}
`;

export const ButtonSelectOperator = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ChatEndedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: fit-content;
  margin: 0 auto;
`;

export const ChatEndedMessage = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  padding: 16px 24px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
  width: 100%;

  p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }
`;

export const ReopenChatButton = styled.button`
  padding: 6px 16px;
  background-color: #00a884;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  width: 100%;
  transition: background-color 0.2s;

  &:hover {
    background-color: #008c6e;
  }
`;

export const ChatAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #fff;
  position: relative;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  color: #8696a0;
  cursor: pointer;
  margin-right: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(134, 150, 160, 0.15);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionDialog = styled.div`
  position: fixed;
  background-color: #222e35;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  min-width: 200px;
  max-width: 300px;
  overflow: hidden;
  transform: translateY(8px);
`;

export const ActionList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

export const ActionItem = styled.div`
  padding: 12px 16px;
  color: #e9edef;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;

  &:hover {
    background-color: rgba(134, 150, 160, 0.15);
  }
`;